import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Half } from '../../../images/redeem-coupon.svg';

export const RedeemCouponIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Half} />
);

export default RedeemCouponIcon;
